import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import './index.scss';
// 未预约按钮底色：红→粉横向渐变（90deg，设计稿 #ff002a → #fe2b92）
const SUBSCRIBE_BTN_COLORS = ['#ff002a', '#fe2b92'];
function ActivityEndedCard(props) {
    const { isSubscribed, feConfig, onSubscribe, onViewWinnerList } = props;
    const { styleConfig, nextActivityConfig } = feConfig ?? {};
    const titleText = nextActivityConfig?.titleText ?? '活动已结束';
    const showSubscribeBtn = !!nextActivityConfig?.appointmentTime;
    return <View className="activity-ended-card__container" style={{
        backgroundColor: styleConfig?.backgroundColor
    }}>
      <LinearGradient className="activity-ended-card__background" colors={[styleConfig?.cardStartColor, styleConfig?.cardEndColor]}/>
      <View className="activity-ended-card__wrapper">
        
        <View className="activity-ended-card__left">
          <Text className="activity-ended-card__title">{titleText}</Text>
          <Button className="activity-ended-card__winner-list-btn" onPress={onViewWinnerList}>
            <Text className="activity-ended-card__winner-list-btn-text">查看上期获奖名单</Text>
            <Image className="activity-ended-card__winner-list-btn-icon" source={{
        uri: 'https://p0.meituan.net/ingee/a3503d2d5f2194667718ae7aea35c9a3424.png'
    }}/>
          </Button>
        </View>
        
        {showSubscribeBtn && <Button className={isSubscribed ? 'activity-ended-card__subscribe-btn--subscribed' : 'activity-ended-card__subscribe-btn'} disabled={isSubscribed} onPress={() => {
        if (!isSubscribed)
            onSubscribe();
    }}>
            
            {!isSubscribed && <LinearGradient className="activity-ended-card__subscribe-btn-gradient" colors={SUBSCRIBE_BTN_COLORS} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }}/>}
            <Text className={isSubscribed ? 'activity-ended-card__subscribe-btn-text--subscribed' : 'activity-ended-card__subscribe-btn-text'}>
              {isSubscribed ? '已预约' : '预约下期'}
            </Text>
          </Button>}
      </View>
    </View>;
}
export default memo(ActivityEndedCard);
